import { useState } from "react";
import { db } from "../api/firebase";
import { ref, push } from "firebase/database";

const siteName = process.env.REACT_APP_SITE_NAME || "GifteKart";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [query, setQuery] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !query) {
      setMessage("Fill all fields");
      return;
    }

    if (!db) {
      setMessage("Service is temporarily unavailable. Please try again shortly.");
      return;
    }

    try {
      await push(ref(db, "enquiries"), {
        email,
        query,
        createdAt: Date.now(),
      });

      setEmail("");
      setQuery("");
      setMessage("Sent ✅");

      setTimeout(() => setMessage(""), 3000);
    } catch {
      setMessage("Error ❌");
    }
  };

  return (
    <footer id="footer-section" className="gk-footer">

      <div className="gk-footer-brand">
        <h4>{siteName}</h4>
        <p className="gk-footer-tagline">Beautiful digital cards, one shareable link.</p>
        <span className="gk-footer-line">support@giftkart.com</span>
        <span className="gk-footer-line">+91 9521873664</span>
      </div>

      <div className="gk-footer-form-wrap">
        <form onSubmit={handleSubmit} className="gk-footer-form">
          <label className="gk-sr-only" htmlFor="footer-email">Email</label>
          <input
            id="footer-email"
            type="email"
            placeholder="Your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="gk-footer-input"
          />

          <label className="gk-sr-only" htmlFor="footer-query">Message</label>
          <input
            id="footer-query"
            placeholder="How can we help?"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="gk-footer-input"
          />

          <button type="submit" className="gk-footer-submit">
            Send message
          </button>
        </form>

        {message && <p className="gk-footer-msg">{message}</p>}
      </div>

    </footer>
  );
}
